import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "feed-topbar flex flex-col w-full" }
const _hoisted_2 = { class: "feed-mobile-only flex flex-col w-full -mt-0.5" }
const _hoisted_3 = { class: "flex w-full justify-between -mt-4" }
const _hoisted_4 = { class: "desktop-shell-layout" }
const _hoisted_5 = { class: "desktop-shell-nav feed-desktop-only" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "desktop-shell-main" }
const _hoisted_8 = {
  key: 0,
  class: "animate-spin h-10 w-10 m-auto text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_9 = {
  key: 0,
  class: "flex h-full w-full"
}
const _hoisted_10 = {
  key: 0,
  class: "flex h-full w-full"
}

import {
  alertController,
  IonContent,
  IonHeader,
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding, IonLabel,
  IonList,
  IonPage,
  IonRefresher,
  IonRefresherContent, IonSegment, IonSegmentButton,
  IonToolbar, isPlatform,
  modalController,
  useIonRouter,
} from '@ionic/vue';
import {computed, defineComponent, inject, onMounted, onUnmounted, Ref, ref} from 'vue';
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import ApiService from "@/services/api/apiService";
import {UserInterface} from "@/interfaces/UserInterface";
import {ChatInterface} from "@/interfaces/ChatInterface";
import FlirtNewChat from "@/views/flirt/FlirtNewChat.vue";
import FlirtViewChat from "@/views/flirt/FlirtViewChat.vue";
import ChatListItem from "@/components/ChatListItem.vue";
import {usePremium} from "@/composables/usePremium";
import {SocialFeedType} from "@/definitions/SocialFeedType";
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import {useVerification} from "@/composables/useVerification";
import ChatItemSliding from "@/components/ChatItemSliding.vue";
import DesktopTopbar from "@/components/DesktopTopbar.vue";
import FeedDesktopSidebar from "@/components/FeedDesktopSidebar.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlirtTab',
  setup(__props) {

const loading = ref(true)
const user: Ref<UserInterface | undefined> = inject('user') as Ref<UserInterface | undefined>
const chats: Ref<ChatInterface[]> = ref([])
const archivedChats: Ref<ChatInterface[]> = ref([])

const ionRouter = useIonRouter()
const observer = ref()

const tab = ref('inbox')
const chatTabs = [
  { label: 'Inbox', value: 'inbox' },
  { label: 'Archive', value: 'archive' },
]
const tabChanged = (event: any) => {
  tab.value = event.detail.value
}
const selectTab = (value: string) => {
  tab.value = value
}

onMounted(async () => {
  try {
    await getChats()
  } finally {
    loading.value = false
  }

  observer.value = Observable.subscribe(async (response: any) => {
    if (response.event === ObservableEvent.ChatsChanged) {
      await getChats()
    }
  })
})

onUnmounted(() => {
  observer.value?.unsubscribe()
})

const getChats = async () => {
  try {
    chats.value = await ApiService.Chat().get()
  } catch (e) {
    console.warn('Failed to load chats', e)
    chats.value = []
  }
  try {
    archivedChats.value = await ApiService.Chat().getArchived()
  } catch (e) {
    console.warn('Failed to load archived chats', e)
    archivedChats.value = []
  }
  Observable.emit(ObservableEvent.UnseenMessagesChanged)
}

const pullToRefresh = async (el: any) => {
  await getChats()
  setTimeout(() => {
    el.target.complete()
  }, 500)
}

const isSubscribed = computed(() => {
  return user.value?.subscribed
})


const newChat = async () => {


  if (isPlatform('capacitor')) await Haptics.impact({style: ImpactStyle.Light});
  if (user.value && !user.value.id_verified) return await useVerification().presentVerificationRequired('You must be verified to start group chats.')



  const modal = await modalController.create({
    component: FlirtNewChat,
    componentProps: {},
    mode: 'ios',
    presentingElement: document.getElementById('tabs') as HTMLElement,
  })
  await modal.present()
}

const deleteChat = async (chatId: number, chatIndex: number) => {
  chats.value.splice(chatIndex, 1)
  await ApiService.Chat().delete(chatId)
}

const viewArchive = () => {
  ionRouter.navigate({
    name: 'FlirtArchive',
  }, 'forward', 'push')
}

const destroyChat = async (chatId: number, chatIndex: number) => {
  archivedChats.value.splice(chatIndex, 1)
  await ApiService.Chat().delete(chatId)
}
const unarchiveChat = async (chatId: number, chatIndex: number) => {
  archivedChats.value.splice(chatIndex, 1)
  await ApiService.Chat().unarchive(chatId)
  await Observable.emit(ObservableEvent.ChatsChanged)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "flirt-page" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(DesktopTopbar, {
                  class: "feed-desktop-only",
                  "show-search": false
                }, {
                  actions: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "desktop-topbar__icon-btn desktop-topbar__icon-btn--primary",
                      "aria-label": "New chat",
                      onClick: newChat
                    }, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("svg", {
                        class: "w-4 h-4 fill-current",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 448 512"
                      }, [
                        _createElementVNode("path", { d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" })
                      ], -1)
                    ]))])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(IonSegment), {
                      onIonChange: tabChanged,
                      value: tab.value,
                      class: "relative z-50 backdrop-blur-2xl bg-opacity-40 ml-0",
                      "swipe-gesture": false,
                      mode: "ios"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonSegmentButton), { value: "inbox" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("Inbox", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSegmentButton), { value: "archive" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), { class: "text-lg font-medium" }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode("Archive", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("div", { class: "flex space-x-4 my-auto" }, [
                      _createElementVNode("div", {
                        onClick: newChat,
                        class: "flex space-x-4 mt-0"
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "rounded-md bg-white w-7 h-7 flex text-brand-black" }, [
                          _createElementVNode("svg", {
                            class: "w-4 h-4 m-auto fill-current",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512"
                          }, [
                            _createElementVNode("path", { d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" })
                          ])
                        ], -1)
                      ]))])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "h-full flex flex-col" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRefresher), {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (pullToRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent), {
                "pulling-icon": "crescent",
                "refreshing-spinner": "crescent"
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("nav", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "feed-create-button",
                onClick: newChat
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4 fill-current",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 448 512"
                }, [
                  _createElementVNode("path", { d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" })
                ], -1),
                _createElementVNode("span", null, "New chat", -1)
              ]))]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chatTabs, (chatTab) => {
                return _createElementVNode("button", {
                  key: chatTab.value,
                  type: "button",
                  class: _normalizeClass(["feed-nav-link", { 'feed-nav-link--active': tab.value === chatTab.value }]),
                  onClick: ($event: any) => (selectTab(chatTab.value))
                }, [
                  _createElementVNode("span", null, _toDisplayString(chatTab.label), 1)
                ], 10, _hoisted_6)
              }), 64))
            ]),
            _createElementVNode("main", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex py-4", {
                'h-full': loading.value || tab.value === 'inbox' && !chats.value.length || tab.value === 'archive' && !archivedChats.value.length,
            }])
              }, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (!loading.value && tab.value === 'inbox')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!chats.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("div", { class: "flex px-4 py-5 m-auto text-white" }, [
                              _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                                _createElementVNode("div", { class: "h-20 w-20 bg-brand-lime text-brand-black rounded-full flex" }, [
                                  _createElementVNode("div", { class: "m-auto" }, [
                                    _createElementVNode("svg", {
                                      class: "w-7 fill-current",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 512 512"
                                    }, [
                                      _createElementVNode("path", { d: "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z" })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-0 px-2" }, [
                                  _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Inbox"),
                                  _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, " You haven’t started chatting with anyone yet. Go on, make the first move... ")
                                ])
                              ])
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (chats.value.length)
                        ? (_openBlock(), _createBlock(_unref(IonList), {
                            key: 1,
                            lines: "none",
                            class: "py-4 flex flex-col w-full text-white space-y-4 bg-brand-black"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chats.value, (chat) => {
                                return (_openBlock(), _createBlock(ChatItemSliding, {
                                  key: chat.id,
                                  chat: chat
                                }, null, 8, ["chat"]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (!loading.value && tab.value === 'archive')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (!archivedChats.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("div", { class: "flex px-4 py-5 m-auto text-white" }, [
                              _createElementVNode("div", { class: "flex flex-col items-center space-y-6" }, [
                                _createElementVNode("div", { class: "h-20 w-20 bg-brand-lime text-brand-black rounded-full flex" }, [
                                  _createElementVNode("div", { class: "m-auto" }, [
                                    _createElementVNode("svg", {
                                      class: "w-7 fill-current",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 512 512"
                                    }, [
                                      _createElementVNode("path", { d: "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z" })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", { class: "flex flex-col w-full items-center space-y-0 px-2" }, [
                                  _createElementVNode("div", { class: "flex text-white text-2xl font-medium text-center" }, "Archive"),
                                  _createElementVNode("div", { class: "text-brand-light-gray text-lg text-center" }, " Once a chat has been archived you will have the option to completely remove a chat. ")
                                ])
                              ])
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (archivedChats.value.length)
                        ? (_openBlock(), _createBlock(_unref(IonList), {
                            key: 1,
                            lines: "none",
                            class: "py-4 flex flex-col w-full text-white space-y-4 bg-brand-black"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(archivedChats.value, (chat, chatIndex) => {
                                return (_openBlock(), _createBlock(_unref(IonItemSliding), {
                                  class: "",
                                  key: chat.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonItem), null, {
                                      default: _withCtx(() => [
                                        _createVNode(ChatListItem, { chat: chat }, null, 8, ["chat"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(IonItemOptions), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonItemOption), {
                                          class: "bg-red-500 text-white font-medium",
                                          onClick: ($event: any) => (destroyChat(chat.id, chatIndex))
                                        }, {
                                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                            _createElementVNode("div", { class: "px-4 flex flex-col space-y-1" }, [
                                              _createElementVNode("div", { class: "flex m-auto" }, [
                                                _createElementVNode("svg", {
                                                  class: "w-6 h-6 fill-current",
                                                  xmlns: "http://www.w3.org/2000/svg",
                                                  viewBox: "0 0 448 512"
                                                }, [
                                                  _createElementVNode("path", { d: "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" })
                                                ])
                                              ]),
                                              _createElementVNode("div", null, "Delete")
                                            ], -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"]),
                                        _createVNode(_unref(IonItemOption), {
                                          class: "bg-brand-lime text-brand-black font-medium",
                                          onClick: ($event: any) => (unarchiveChat(chat.id, chatIndex))
                                        }, {
                                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                            _createElementVNode("div", { class: "px-4 flex flex-col space-y-1" }, [
                                              _createElementVNode("div", { class: "flex m-auto" }, [
                                                _createElementVNode("svg", {
                                                  class: "w-6 h-6 fill-current",
                                                  xmlns: "http://www.w3.org/2000/svg",
                                                  viewBox: "0 0 512 512"
                                                }, [
                                                  _createElementVNode("path", { d: "M288 109.3V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM48 320h76.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H464c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z" })
                                                ])
                                              ]),
                                              _createElementVNode("div", null, "Unarchive")
                                            ], -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createVNode(FeedDesktopSidebar, { class: "feed-desktop-only" })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})